import i18next from "i18next";
import Axios from "../../axios";
import ReturnExceptionsError from "../ReturnExceptionsError";
import { toast } from "react-hot-toast";
import handleInitialization, {
    handleExistingAllergies,
} from "./handleInitialization";
/**
 * Async function to get all resources from API, and
 * set them to localStorage
 * @returns {boolean}  initialization_success
 */
const AppInitializer = async (
    setLoading,
    setIsAppInitializerSuccess,
    handleCount,
) => {
    // here should setLoading(true), but it already handled in Oauth.js:31, so no need to handle it here
    let initialization_success = false;
    try {
        if (JSON.parse(localStorage.initialization || "{}") === "callAPI") {
            const loadingToastId = toast.loading(i18next.t("common:loading"));
            const response_1 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}employees/`,
            );
            const response_2 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}employees/?has_appointments=true`,
            );
            const response_3 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}clinics/`,
            );
            const response_4 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}rooms/`,
            );
            const response_5 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}employees-appointment-assignable/?is_appointment_assignable=true`,
            );
            const response_6 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}employees-appointment-assignable/`,
            );
            const response_7 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}provinces/`,
            );
            let cities = {};
            for (const province of response_7?.data) {
                const response_of_this_province = await Axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}cities/?province=${province?.choice}`,
                );
                cities[province?.choice] = response_of_this_province?.data;
            }
            const response_8 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}choices/patient-status/`,
            );
            const response_9 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}choices/relationship-to-patient/`,
            );
            const response_10 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}studies/`,
            );
            const response_11 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}employee-scheduler-configuration/`,
            );
            const response_12 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}allergies/`,
            );
            const response_13 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}studies/`,
                {
                    params: {
                        clinic: response_3?.data?.find(
                            (clinic) => clinic.name === "ottawa",
                        )?.uuid,
                    },
                },
            );
            const response_14 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}studies/`,
                {
                    params: {
                        clinic: response_3?.data?.find(
                            (clinic) => clinic.name === "montreal",
                        )?.uuid,
                    },
                },
            );
            const response_15 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}source-categories/`,
            );
            const response_16 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}msgroups/app_sh_ip_prep/employees/`,
            );
            const response_17 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}msgroups/app_sh_onleave/employees/`,
            );
            const response_18 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}choices/file-categories/`,
            );
            let fileSubcategories = {};
            let fileSubcategoriesAll = [];
            for (const category of response_18?.data) {
                const subcategory_of_this_category = await Axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}choices/file-subcategories/?category=${category?.choice}`,
                );
                fileSubcategories[category?.choice] =
                    subcategory_of_this_category?.data;
                fileSubcategoriesAll = fileSubcategoriesAll.concat(
                    subcategory_of_this_category?.data,
                );
            }
            const response_19 = await Axios.get(
                `${process.env.REACT_APP_API_BASE_URL}choices/waitlist-categories/`,
            );
            let waitlistSubcategories = {};
            let waitlistSubcategoriesAll = [];
            for (const category of response_19?.data) {
                const subcategory_of_this_category = await Axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}choices/waitlist-subcategories/?category=${category?.choice}`,
                );
                waitlistSubcategories[category?.choice] =
                    subcategory_of_this_category?.data;
                waitlistSubcategoriesAll = waitlistSubcategoriesAll.concat(
                    subcategory_of_this_category?.data,
                );
            }
            if (
                response_1.data?.length > 0 &&
                // response_2.data?.length > 0 && // in DEV environment, there might be no appointment, so this is not necessary
                response_3.data?.length > 0 &&
                response_4.data?.length > 0 &&
                response_5.data?.length > 0 &&
                response_6.data?.length > 0 &&
                response_7.data?.length > 0 &&
                response_8.data?.length > 0 &&
                response_9.data?.length > 0 &&
                response_10.data?.length > 0 &&
                // && response_11.data?.length > 0 // this is not necessary because at the fisrt time, it will be empty
                response_13.data?.length > 0
            ) {
                handleInitialization(
                    response_1.data,
                    response_2.data,
                    response_3.data,
                    response_4.data,
                    response_5.data,
                    response_6.data,
                    response_7.data,
                    cities,
                    response_8.data,
                    response_9.data,
                    response_10.data,
                    response_11.data?.[0]?.configuration,
                    response_12.data,
                    response_13.data,
                    response_14.data,
                    response_15.data,
                    response_16.data,
                    response_17.data,
                    response_18.data,
                    fileSubcategories,
                    fileSubcategoriesAll,
                    response_19.data,
                    waitlistSubcategories,
                    waitlistSubcategoriesAll,
                );
                initialization_success = true;
                localStorage.initialization = JSON.stringify("done");
                toast.dismiss(loadingToastId);
                setLoading(false);
                setIsAppInitializerSuccess(true);
                handleCount();
            } else {
                throw new ReturnExceptionsError(
                    i18next.t("errors:err_initialization"),
                );
            }
        }
        if (JSON.parse(localStorage.initialization || "{}") === "done") {
            initialization_success = true;
        }
    } catch (err) {
        toast.error(err.message);
    } finally {
        console.info(`\u2605 App Initialization Done`);
        return initialization_success;
    }
};
export default AppInitializer;
export const getExistingAllergies = async () => {
    try {
        const response = await Axios.get(
            `${process.env.REACT_APP_API_BASE_URL}allergies/`,
        );
        if (response.data.length > 0) {
            handleExistingAllergies(response.data);
        }
    } catch (err) {
        toast.error(err.message);
    } finally {
        console.info(`\u2605 Get All Allergies Done`);
    }
};
